import React, { useState } from 'react';
import styles from './ImageAIVideoPopUP.module.scss';
import icons from '../../assets';
import { ModalArea } from '../../common/ModalButtonArea';
import AIVIdeo from '../../assets/ai_data/ai_video.mp4';
import { BigButton } from '../../common';
import { AI_WEBSITE_URL } from '../../constants/routePathConstants';
import { getLocalStorage } from '../../helpers/jsHelper';

function ImageAIVideoPopUP({ show, setShow }) {
  const [showModal, setShowModal] = useState(false);

  const { AIVideoPlayIcon, InfoIcon, CrossIcon } = icons;

  const handleRedirect = () => {
    const token = getLocalStorage('token');
    window.open(AI_WEBSITE_URL + `?token=${encodeURIComponent(token)}`, '_blank');
  };

  const handleClose = () => {
    setShowModal(false);
          setShow(false);
  }

  return (
    <>
      <div
        className={`${styles.container} ${show && !showModal ? styles.show : ''}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShow(false);
          setShowModal(!showModal);
        }}>
        <div className={styles.area}>
          <AIVideoPlayIcon /> See how it works
        </div>
        {/* <div className={styles.footer}>
          {' '}
          <InfoIcon /> This feature is still in alpha.
        </div> */}
      </div>
      <ModalArea
        showModal={showModal}
        setShowModal={handleClose}
        size="xl"
        hideCloseButton={true}
        centered={true}
        contentClassName={styles.modelContent}
        backdropClassName={styles.modalBackdrop}
        body={
          <div className={styles.videoContainer}>
            <div className={styles.modalCloseButton} onClick={handleClose}><CrossIcon /></div>
            <video
              className={styles.video}
              loop
              muted={false}
              autoPlay
              playsInline
              controls
              controlsList="nodownload"
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}>
              <source src={AIVIdeo} type="video/mp4" />
            </video>
            <div className={styles.footer}>
              {/* <div className={styles.info}>
                <InfoIcon /> This feature is still in alpha.
              </div> */}
              <BigButton buttonTitle="Try it now" className="lf-btn-1" onClick={handleRedirect} />
            </div>
          </div>
        }
      />
    </>
  );
}

export default ImageAIVideoPopUP;
